import React, { createContext, useContext, useState, useEffect } from 'react';
import fr from './fr';
import en from './en';

const translations = { fr, en };

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    return localStorage.getItem('inventotrack_lang') || 'en';
  });

  useEffect(() => {
    localStorage.setItem('inventotrack_lang', lang);
  }, [lang]);

  const t = (key, params = {}) => {
    const keys = key.split('.');
    let value = translations[lang];
    for (const k of keys) {
      value = value?.[k];
    }
    if (typeof value !== 'string') {
      return value || key;
    }
    return Object.entries(params).reduce((result, [paramKey, paramValue]) => {
      return result.replaceAll(`{${paramKey}}`, String(paramValue));
    }, value);
  };

  const toggleLang = () => {
    setLang(prev => prev === 'fr' ? 'en' : 'fr');
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, toggleLang }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useTranslation() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useTranslation must be used within a LanguageProvider');
  }
  return context;
}

export { LanguageContext };
